// extracted by mini-css-extract-plugin
module.exports = {"container":"ColorBackgroundSelector_container__2nijm","magnifier":"ColorBackgroundSelector_magnifier__3oyzO"};